<header>
  <app-nav-menus></app-nav-menus>
</header>
<section>
  <div class="container" id="app-container">
    <router-outlet></router-outlet>
  </div>
</section>
<footer>
  <app-footer></app-footer>
</footer>
